function getLineHeightPx(el) {
  const styles = window.getComputedStyle(el)
  const lineHeight = parseFloat(styles.getPropertyValue('line-height'))

  return lineHeight || parseFloat(styles.getPropertyValue('font-size')) * 1.2
}

export function computeTruncatedText({
  clampingLinesCount,
  fullText,
  measureEl,
  measureTail,
  measureText,
  truncationSymbol,
}) {
  const lineHeight = getLineHeightPx(measureText)
  const tailHeight = measureTail.offsetHeight

  const linesHeight = lineHeight * clampingLinesCount

  const maxHeight =
    tailHeight > lineHeight
      ? linesHeight + (tailHeight - lineHeight)
      : linesHeight

  measureText.textContent = fullText

  if (maxHeight >= measureEl.scrollHeight) {
    return { needsTruncate: false, renderText: fullText }
  } else {
    let left = 0
    let right = fullText.length
    let bestFit = 0

    while (left <= right) {
      const mid = (left + right) >> 1
      const candidate = fullText.slice(0, mid).trimEnd() + truncationSymbol

      measureText.textContent = candidate

      if (measureEl.scrollHeight <= maxHeight) {
        bestFit = mid
        left = mid + 1
      } else {
        right = mid - 1
      }
    }

    const truncatedText = fullText.slice(0, bestFit).trimEnd()

    return {
      needsTruncate: true,
      renderText: truncatedText + truncationSymbol,
    }
  }
}
